import { CircularProgress, Modal } from '@mui/material';
import classNames from 'classnames';
import { FC, useCallback, useEffect, useState } from 'react';

import { useActions } from '../../hooks/useActions';
import { useLayout } from '../../hooks/useLayout';
import { useMain } from '../../hooks/useMain';
import {
  IMainCatalogChild,
  IMainCatalogItem,
} from '../../shared/types/main-catalog';

import CatalogItem from './CatalogItem';
import './CatalogMenu.sass';
import CatalogMenuItem from './CatalogMenuItem';

interface IFadeMenu {
  anchorEl: boolean;
}
// Меню каталога
export const CatalogMenu: FC<IFadeMenu> = ({ anchorEl }) => {
  const { setVisibleCatalogMenu } = useActions();
  const { processes, materials, equipments } = useMain();
  const { page } = useLayout();
  //Активный элемент
  const [tooltipIsOpen, setTooltipIsOpen] = useState<IMainCatalogChild>(
    {} as IMainCatalogChild
  );
  //Первый активный элемент левой части меню. Изначально будет стоять = Производственные технологии
  const [tooltipIsOpenActive, setTooltipIsOpenActive] = useState<any>(261);
  //Первый активный элемент левой части меню. Изначально будет стоять = Процессы
  const [firstOpenCategory, setFirstOpenCategory] = useState('processes');
  const data = Object.entries({ processes, materials, equipments });
  const open = Boolean(anchorEl);

  //Закрыть при клике
  const handleClose = useCallback(() => {
    setVisibleCatalogMenu(false);
  }, []);
  //Показать при наведении
  const onMouseMoveCatalogItem = (obj: IMainCatalogItem) => {
    setTooltipIsOpen(obj);
    setTooltipIsOpenActive(obj.id);
  };

  useEffect(() => {
    if (processes.length !== 0) {
      setTooltipIsOpen(processes[0]);
      setTooltipIsOpenActive(processes[0].id);
    }
  }, [processes, materials, equipments, page]);

  useEffect(() => {
    setFirstOpenCategory('processes');
  }, [page]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        zIndex: 2,
        '& .MuiBackdrop-root': { backgroundColor: 'transparent' },
      }}
      hideBackdrop
    >
      <div
        className={classNames('catalog-menu ', firstOpenCategory, {
          'processes-custom': tooltipIsOpenActive === 84,
        })}
      >
        <div className="catalog-menu__wrapper">
          <div className="catalog-menu__custom"></div>
          <div className="catalog-menu-left">
            <div className="catalog-menu-top">
              <ul className="catalog-menu-top__lists">
                {processes.length !== 0 ? (
                  tooltipIsOpen &&
                  processes &&
                  data.map((item) => {
                    return (
                      <CatalogItem
                        key={item[0]}
                        setOpenCategory={setFirstOpenCategory}
                        item={item}
                        openCategory={firstOpenCategory}
                        onMouseCatalogItem={onMouseMoveCatalogItem}
                        tooltipIsOpen={tooltipIsOpen}
                        handleClose={handleClose}
                      />
                    );
                  })
                ) : (
                  <CircularProgress />
                )}
              </ul>
            </div>
          </div>

          {tooltipIsOpen?.id === tooltipIsOpenActive && (
            <div
              className={classNames('catalog-menu-right', {
                custom: tooltipIsOpen?.id === 637,
              })}
            >
              <ul
                className={classNames(
                  'catalog-menu__children',
                  firstOpenCategory
                )}
              >
                {processes.length !== 0 &&
                  tooltipIsOpen?.children?.map((child: any) => {
                    return (
                      <CatalogMenuItem
                        key={child?.id}
                        child={child}
                        handleClose={handleClose}
                        openCategory={firstOpenCategory}
                        tooltipIsOpen={tooltipIsOpen}
                      />
                    );
                  })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
